import { render, staticRenderFns } from "./ArticleParts.vue?vue&type=template&id=805559f0&scoped=true&"
import script from "./ArticleParts.vue?vue&type=script&lang=js&"
export * from "./ArticleParts.vue?vue&type=script&lang=js&"
import style0 from "./ArticleParts.vue?vue&type=style&index=0&id=805559f0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805559f0",
  null
  
)

export default component.exports